export const environment = {
    seedFunctionApiUrl: 'https://func-seh-prd-uks-002-h8b6asaqdmgkbvc3.uksouth-01.azurewebsites.net/api/{0}?code=T667PV_Q-jPt05VmQA6L_qHu6XUMV96aDcsZo5V48Vv9AzFus1qIvQ==',
    sehApiUrl : 'https://app-seh-prd-uks-101.azurewebsites.net/api/',
    msalConfig: {
        auth: {
            clientId: 'c8de7f2e-f8b5-4bf4-94a9-6c87dbbad84c',
            authority: 'https://login.microsoftonline.com/01583be4-f096-49f4-bd19-56b649a8482f',
            redirectUri: 'https://admin.seh.icshosting.net/auth',
        },
    },
    apiConfig: {
        scopes: ['api://cc318d2b-1ab0-4cc0-9d59-416b07724ddb/access_as_user'],
        uri: 'https://app-seh-prd-uks-101.azurewebsites.net/api/',
    }
};
